import { type HTMLAttributes } from 'react';
import { cn } from './cn';

export type SkeletonProps = HTMLAttributes<HTMLDivElement>;

export const Skeleton = ({ className, style, ...props }: SkeletonProps) => (
  <div
    className={cn('animate-pulse rounded', className)}
    style={{
      background: 'linear-gradient(90deg, var(--surface-1) 25%, var(--divider-soft) 50%, var(--surface-1) 75%)',
      backgroundSize: '200% 100%',
      ...style,
    }}
    aria-hidden="true"
    {...props}
  />
);
